import * as React from 'react'
import { matchPath, RouteComponentProps } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'
import Auth from '../../service/auth'
import SecuredComponent, { SecuredComponentProps } from './secured-component'
import * as actionCreators from "../../action-creators"
import * as routes from '../../util/routes'
import * as errors from '../../util/errors'
import { ReducerState, MappedActionsProps } from '../../reducer'
import ReactGA from "react-ga4";

class SecuredContainer extends React.Component<InjectedProps, State> {
    constructor(props: Readonly<InjectedProps>) {
        super(props)
        this.state = { menuOpen: true };
    }

    componentDidMount() {        
        window.localStorage.setItem('fetchedTableData', "calculating");
        // shows the menu during 500ms then closes it
        setTimeout(() => {
            this.setState({ menuOpen: false });
        }, 500)

        this.props.actions.fetchLocalAuthorities();
        this.props.actions.fetchCurrentUser();

        if (!this.props.location) {
            return this.props.history.replace('/');
        }

        const match = matchPath<Params>(
            this.props.location.pathname,
            { path: routes.LOCAL_AUTHORITY_PATTERN }
        )

        if (!match) return;
        this.props.actions.fetchCurrentLocalAuthorityIfNeeded(match.params.slug);
    }

    componentDidUpdate(prevProps: InjectedProps) {
        if (!prevProps.currentUser && this.props.currentUser) {
            const { username, roles } = this.props.currentUser
            const slug = roles[0] === "ROLE_SUPER_ADMIN" ? this.props.currentLocalAuthority && this.props.currentLocalAuthority.slug : this.props.currentUser.relatedLocalAuthoritySlug
            slug ? ReactGA.ga('send', 'event', "Login", `${username} ${slug} ${roles[0]}`) : ReactGA.ga('send', 'event', "Login", `${username} ${roles[0]}`)
        }
        if (prevProps.location.pathname !== this.props.location.pathname) {
            if (this.props.currentUser && this.props.currentLocalAuthority) {
                const { code, name, slug } = this.props.currentLocalAuthority
                const { username, roles } = this.props.currentUser
                ReactGA.send("pageview")
                ReactGA.ga('send', 'event', "Navigation", `${username} ${slug} ${roles[0]}`)
            } else if (!this.props.currentLocalAuthority && this.props.currentUser) {
                ReactGA.send("pageview")
                const { username, roles } = this.props.currentUser
                ReactGA.ga('send', 'event', "Navigation", `${username} ${roles[0]}`)
            }
            // this.props.actions.fetchLocalAuthorities();
            // this.props.actions.fetchCurrentUser();
            if (this.props.currentLocalAuthority !== prevProps.currentLocalAuthority) {
                window.localStorage.setItem('fetchedTableData', "calculating");
            }
            document.title = this.props.title + ' | SFP Collectivités';
            const currentLocalAuthority = this.props.currentLocalAuthority;
            let error = this.props.error;

            if (error && errors.INVALID_GRANT === error.error) {
                Auth.signOut();
                this.props.history.replace(this.props.location);
            }

            if (currentLocalAuthority && (this.props.currentLocalAuthority && currentLocalAuthority.id !== this.props.currentLocalAuthority.id)) {
                // récupérer l'ancienne collectivité en utilisant props.match
                // créer un nouveau chemin (pathname ?) en remplaçant l'ancienne collectivité par la nouvelle
                // utiliser history.push pour rediriger vers le nouveau chemin
                let pathname = this.props.location.pathname.replace(prevProps.currentLocalAuthority.slug, this.props.currentLocalAuthority.slug)

                // ne surtout pas utiliser window.location
                // le routeur (history, location, match, etc) est là pour ça
                this.props.history.push(pathname)
            }
        }
        if (prevProps.location.pathname === this.props.location.pathname &&
            this.props.currentLocalAuthority &&
            prevProps.currentLocalAuthority !== this.props.currentLocalAuthority &&
            this.props.currentUser !== prevProps.currentUser) {
            const { code, name, slug } = this.props.currentLocalAuthority
            const { username, roles } = this.props.currentUser
            ReactGA.send("pageview")
            ReactGA.ga('send', 'event', "Navigation", `${username} ${slug} ${roles[0]}`)
        }
    }

    componentWillReceiveProps(nextProps: InjectedProps) {
        document.title = nextProps.title + ' | SFP Collectivités';
        const currentLocalAuthority = this.props.currentLocalAuthority;
        let error = nextProps.error;
        if (!this.props.currentUser && nextProps.currentUser && this.props.currentUser != nextProps.currentUser) {
            ReactGA.send("pageview")
            const { username, roles } = nextProps.currentUser
            ReactGA.ga('send', 'event', "Navigation", `${username} ${roles[0]}`)
        }
        if (error && errors.INVALID_GRANT === error.error) {
            Auth.signOut();
            this.props.history.replace(this.props.location);
        }

        if (currentLocalAuthority && (nextProps.currentLocalAuthority && currentLocalAuthority.id !== nextProps.currentLocalAuthority.id)) {
            // récupérer l'ancienne collectivité en utilisant props.match
            // créer un nouveau chemin (pathname ?) en remplaçant l'ancienne collectivité par la nouvelle
            // utiliser history.push pour rediriger vers le nouveau chemin
            let pathname = nextProps.location.pathname.replace(this.props.currentLocalAuthority.slug, nextProps.currentLocalAuthority.slug)

            // ne surtout pas utiliser window.location
            // le routeur (history, location, match, etc) est là pour ça
            this.props.history.push(pathname)
        }
    }

    render() {
        const securedComponentProps: SecuredComponentProps = {
            currentLocalAuthority: this.props.currentLocalAuthority,
            currentLocalAuthorityLoans: this.props.currentLocalAuthorityLoans,
            currentUser: this.props.currentUser,
            loadingCurrentLocalAuthority: this.props.loadingCurrentLocalAuthority,
            loadingCurrentUser: this.props.loadingCurrentUser,
            loadingLocalAuthorities: this.props.loadingLocalAuthorities,
            loans: this.props.currentLocalAuthorityLoans,
            localAuthorities: this.props.localAuthorities,
            onLogout: this._handleLogout,
            menuOpen: this.state.menuOpen,
            onLocalAuthorityChange: this._handleLocalAuthorityChange,
            onMenuButtonClick: this._handleMenuButtonClick,
            onMenuItemClick: this._handleMenuItemClick,
            setLoaderValue: this._setLoaderValue,
            fetchedTableDataValue: this._fetchedTableDataValue,
            title: this.props.title,
            loaderStoreData: this.props.loaderStoreData,
            totalCalls: this.props.totalCalls,
            ongoingCalls: this.props.ongoingCalls,
            allCallFinished: this.props.allCallsFinished,
            setTotalCalls: this._setTotalCalls,
            incrementCall: this._incrementCall,
            finishCall: this._finishCall,
            allCallsFinished: this._allCallsFinished,
            resetOngoingCalls: this._resetOngoinCalls
        }

        return <SecuredComponent {...securedComponentProps} />
    }

    private _allCallsFinished = (data: boolean) => {
        this.props.actions.allCallsFinished(data)
    }
    private _resetOngoinCalls = () => {
        this.props.actions.reset_OnGoinCall()
    }
    private _setTotalCalls = (data: number) => {
        this.props.actions.setTotalCalls(data)
    }
    private _incrementCall = () => {
        this.props.actions.incrementCall()
    }
    private _finishCall = () => {
        this.props.actions.finishCall()
    }

    private _setLoaderValue = (data) => {
        this.props.actions.setLoaderValue(data)
    }

    private _fetchedTableDataValue = (fetchedTableData) => {
        this.props.actions.fetchedTableDataValue(fetchedTableData)
    }

    private _closeMenu = () => {
        this.setState({ menuOpen: false });
    }

    private _handleLocalAuthorityChange = (id: number) => {
        this.props.actions.fetchCurrentLocalAuthorityIfNeeded(id);
    }

    private _handleLogout = () => {
        Auth.signOut();
        this.props.history.push(routes.LOGIN);
    }

    private _handleMenuButtonClick = () => {
        this._toggleMenu();
    }

    private _handleMenuItemClick = () => {
        this._closeMenu();
    }

    private _toggleMenu = () => {
        this.setState(prevState => ({
            menuOpen: !prevState.menuOpen
        }));
    }
}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
    return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
    return state
}

export default connect(mapStateToProps, mapDispatchToProps)(SecuredContainer);

export interface Props {
}

interface Params {
    slug: string
}

interface State {
    menuOpen: boolean
}

type InjectedProps = MappedActionsProps &
    Props &
    ReducerState &
    RouteComponentProps<Params>



// WEBPACK FOOTER //
// ./src/route/secured/secured-container.tsx